var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var TermCheckbox_1;
import { AwesomeComponent, ComponentType } from '@philips-internal/oswald-ui-core';
import './term-checkbox.css';
import React, { PureComponent } from 'react';
import { Checkbox, Link } from '@philips-internal/oswald-ui-components';
import { generateUUID, getLostProps, propagateProps } from '@philips-internal/oswald-ui-utils';
import { bool, eventListener } from '@philips-internal/oswald-ui-core/lib/component/prop-types';
import { MessageService } from '@philips-internal/oswald-ui-core/lib/services';
import { Size } from '@philips-internal/oswald-ui-constants';
import TermCheckApi from './term-checkbox-api';
let TermCheckbox = class TermCheckbox extends PureComponent {
    static { TermCheckbox_1 = this; }
    static { this.propTypes = {
        enabled: bool,
        onClickAviso: eventListener,
        onClickTermo: eventListener,
        onClickTermoConsent: eventListener,
        value: bool,
    }; }
    getCheckbox() {
        const { value } = this.props;
        const lostProps = getLostProps(TermCheckbox_1, this.props);
        const uuidComponent = generateUUID();
        return propagateProps(React.createElement(Checkbox, { value: value, uuid: uuidComponent, name: uuidComponent }), { ...this.props, ...lostProps });
    }
    getLinks() {
        const { onClickTermo } = this.props;
        return (React.createElement(React.Fragment, null,
            React.createElement("span", null,
                MessageService.translate('newaccount.text.agree.with.the'),
                "\u00A0",
                React.createElement(Link, { value: 'newaccount.link.terms.ofuse', onClick: onClickTermo }))));
    }
    getPrivacyLink() {
        const { onClickAviso } = this.props;
        return (React.createElement("div", { style: { marginLeft: '2rem', marginTop: '0.5rem' } },
            React.createElement("span", { style: { fontSize: '0.875em' } }, MessageService.translate('patient.label.read-our')),
            "\u00A0",
            React.createElement(Link, { value: 'newaccount.link.privacy.notice', size: Size.MEDIUM, onClick: onClickAviso })));
    }
    renderComponents() {
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: 'c-term-checkbox__wrapper' },
                React.createElement("div", { className: 'c-term-checkbox__checkbox' }, this.getCheckbox()),
                React.createElement("div", { className: 'c-term-checkbox__link' }, this.getLinks())),
            this.getPrivacyLink()));
    }
    render() {
        return this.renderComponents();
    }
};
TermCheckbox = TermCheckbox_1 = __decorate([
    AwesomeComponent({ api: TermCheckApi, type: ComponentType.DATA_ENTRY })
], TermCheckbox);
export default TermCheckbox;
//# sourceMappingURL=term-checkbox.js.map